
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkScreenslideLayoutEnum } from '../models/work-screenslide-layout-enum';
import { requiredBoolean } from './required-boolean.validator';
import { WorkScreenslideComponentsEffect } from '../models/work-screenslide-components-effect';

export function getCreateScreenslideDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(255)]),
    layout: new FormControl<WorkScreenslideLayoutEnum | undefined>(undefined, [Validators.required]),
    active: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    refreshInSeconds: new FormControl<number | undefined>(undefined),
    durationInSeconds: new FormControl<number | undefined>(undefined),
    title: new FormControl<string | undefined>(undefined),
    richText: new FormControl<string | undefined>(undefined),
    effect: new FormControl<WorkScreenslideComponentsEffect | undefined>(undefined),
    websiteUrl: new FormControl<string | undefined>(undefined),
})
;
}
      